import type { AgeDef } from '../types';

/**
 * The six ages of Emberline. Each age is a self-contained act with its own
 * resources, jobs and technologies, gated by a capstone technology and a
 * minimum number of completed generations.
 */
export const AGES: AgeDef[] = [
  {
    index: 0,
    id: 'scavenging',
    name: 'Age of Scavenging',
    subtitle: 'Hands and hunger',
    description:
      'No fire. No tools worth the name. The tribe walks, and what it finds it eats. ' +
      'Stone breaks stone; dry grass waits for a spark that has not come.',
    generationsRequired: 3,
    capstoneTech: 'controlledFire',
    eraMultiplier: 1,
  },
  {
    index: 1,
    id: 'fire',
    name: 'Age of Fire',
    subtitle: 'The line begins',
    description:
      'The spark is caught and kept. Cooked food gives more than raw. ' +
      'One member of the tribe now has only one duty: the fire must not die.',
    generationsRequired: 4,
    capstoneTech: 'hafting',
    eraMultiplier: 1.6,
  },
  {
    index: 2,
    id: 'hunt',
    name: 'Age of the Hunt',
    subtitle: 'Stone bound to wood',
    description:
      'A blade lashed to a shaft changes everything. The tribe stops waiting for ' +
      'meat to die and starts deciding when it does.',
    generationsRequired: 5,
    capstoneTech: 'cordage',
    eraMultiplier: 2.56,
  },
  {
    index: 3,
    id: 'shelter',
    name: 'Age of Shelter',
    subtitle: 'Walls against the dark',
    description:
      'Twisted fibre holds timber to timber. The tribe stops sleeping where night ' +
      'finds it and starts sleeping where it chooses.',
    generationsRequired: 6,
    capstoneTech: 'symbols',
    eraMultiplier: 4.1,
  },
  {
    index: 4,
    id: 'lore',
    name: 'Age of Lore',
    subtitle: 'Marks that outlive the hand',
    description:
      'Ochre on stone. A hand pressed to the wall says: I was here, and this is what ' +
      'I knew. Knowledge stops dying with the knower.',
    generationsRequired: 7,
    capstoneTech: 'theSeed',
    eraMultiplier: 6.55,
  },
  {
    index: 5,
    id: 'seeds',
    name: 'Age of Seeds',
    subtitle: 'The last wandering',
    description:
      'A seed dropped near camp came back as food. The tribe understands, and stops ' +
      'walking. Everything after this is a different story.',
    generationsRequired: 8,
    capstoneTech: 'settlement',
    eraMultiplier: 10.5,
  },
];

export const FINAL_AGE_INDEX = AGES.length - 1;

export function getAge(index: number): AgeDef {
  return AGES[Math.min(Math.max(index, 0), FINAL_AGE_INDEX)];
}
